import React from "react";
import { Box, ThemeProvider, Typography } from "@mui/material";
import logo from "./../assets/logo.png";
import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/material/Link";
import themes from "../themes";

function Header({ title, href, visible }) {
  return (
    <Box
      component="header"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#f5f5f5",
        px: { xs: 2, md: 3 },
        py: { xs: 1, md: 1.5 },
      }}
    >
      {/* Logo */}
      <Box
        component="img"
        src={logo}
        alt="MyApp Logo"
        sx={{
          width: { xs: "60%", sm: "45%", md: 300, lg: 350 }, // smaller than before
          maxWidth: 500,
          objectFit: "contain",
        }}
      />
      {/* Button */}
      {visible && <Link
        component={RouterLink}
        to={href}
        sx={{
          textDecoration: "none",
          fontSize: { xs: "0.85rem", md: "1rem" },
          fontWeight: "bold",
          color: "#fff",
          px: { xs: 2, md: 3 },
          py: { xs: 0.6, md: 1 },
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
          backgroundColor: "#424242",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: "#2f2f2f",
          },
        }}

      >
       <Typography>{title}</Typography> 
      </Link>
      }

    </Box>
  );
}

export default Header;
